module.exports = __webpack_public_path__ + "static/media/ForwardProgressDesktop.9ff9b4b8.svg";